import { ModalStore } from '../../../state/ModalStore'
import PremiumLeadListCallModal from '../../Modals/PremiumLeadListCall'
import GradientButton from '../GradientButton'
import WhiteButton from '../WhiteButton'

function BookACallPremiumList({
    children = 'Book A Coaching Call',
    scheme = 'default',
    Modal = PremiumLeadListCallModal,
    modalProps,
}) {
    const addModal = ModalStore((state) => state.add)

    const handleClick = () => {
        addModal(<Modal {...modalProps} />)
    }

    return scheme === 'white' ? (
        <WhiteButton onClick={handleClick}>{children}</WhiteButton>
    ) : (
        <GradientButton onClick={handleClick}>{children}</GradientButton>
    )
}

export default BookACallPremiumList
